import { Injectable } from '@angular/core';
import { AbcCoreModule } from './../abc-core.module';
import { DataService } from './../data/src/lib/data.service';
import { CordovaPushAdapter } from './cordova-push-adapter';
import { FirebasePushAdapter } from './firebase-push-adapter';
import { PushAdapter } from './push-adapter-base';
import { PushAdapterSettings } from '../models/notifications.model';
import { CordovaService } from '../cordova.service';

@Injectable({
  providedIn: AbcCoreModule,
})
export class NotificationsService {
  constructor() {}

  public async tryCreatePushAdapter(
    coreDataService: DataService,
    channelIdentifier: string,
    cordovaService?: CordovaService,
    serviceWorkerUrlFireBase?: string,
    settings?: PushAdapterSettings,
    clientIdentifier?: string,
  ): Promise<PushAdapter> {
    if (cordovaService && CordovaService.isCordovaEnvironmentDetected) {
      return new CordovaPushAdapter(coreDataService, cordovaService, channelIdentifier, settings, clientIdentifier);
    } else if (serviceWorkerUrlFireBase && (await FirebasePushAdapter.isAvailable())) {
      return new FirebasePushAdapter(
        coreDataService,
        channelIdentifier,
        serviceWorkerUrlFireBase,
        settings,
        clientIdentifier,
      );
    }

    return undefined;
  }
}
